import React, { createContext, useState, FC } from "react";
import PropTypes from "prop-types";
import { MainContextType } from '../interface-type'
import Config from '../config'

const MainContext = createContext<any | null>(null);



const MainContextProvider: FC = (props: any) => {
  const [state, setstate] = useState<MainContextType>({
    hostV: props.hostV,
    apikeyV: props.apikeyV,
    tokenV: props.tokenV,
    userIdV: props.userIdV,
    hostA: props.hostA,
    tokenA: props.tokenA
  });
  return (
    <MainContext.Provider value={{ ...state, setstate }}>
      {props.children}
    </MainContext.Provider>
  );
};
MainContextProvider.defaultProps = {
  hostV: Config.vallarisUrl,
  apikeyV: null,
  tokenV: null,
  userIdV: null,
  hostA: Config.andamanUrl,
  tokenA: null
};

MainContextProvider.propTypes = {
  hostV: PropTypes.string,
  apikeyV: PropTypes.string,
  tokenV: PropTypes.string,
  userIdV: PropTypes.number,
  hostA: PropTypes.string,
  tokenA: PropTypes.string
};

export { MainContext, MainContextProvider };
